<script>
import HKLInput from '@/controls/Input/HKLInput.vue'

/**
 * @param {KeyboardEvent} event
 * @param {string} oldValue
 */
export function onKeyPress (event, oldValue) {
  const nextChar = event.key
  const [startIndex, endIndex] = [event.target.selectionStart, event.target.selectionEnd]
  const newVal = `${oldValue.substr(0, startIndex)}${nextChar}${oldValue.substr(endIndex, oldValue.length)}`
  return onKeyPressValidation(newVal)
}

export const onKeyPressValidation = (text) => {
  const regexMap = {
    /**
     * Allow interger string
     * @example 123
     * @example 1,2,3
     */
    integer: `\\d(,?\\d)*,?`,
    /**
     * Allow decimal string
     * @example .
     * @example .12
     * @example .1,2
     */
    decimal: `(\\.([\\d,]+)?)?`,
  }
  const is = [
    new RegExp(`^(${regexMap.integer}${regexMap.decimal})?$`).test(text),
    !(new RegExp(`,,`).test(text)),
  ]
  return !is.includes(false)
}

/**
 * @type {import('vue').Component}
 */
const HKLInputNumber = {
  extends: HKLInput,
  methods: {
    listenerProcess (listener) {
      listener.keypress = (e) => {
        return onKeyPress(e, this.realValue) || e.preventDefault()
      }
      return listener
    },
  },
}

export default HKLInputNumber
</script>
